<template>
    <el-dialog title="新增活动" :visible.sync="centerDialogVisible" width="580px" class="selectWay">
        <div class="wayBox">
            <div @click="changeWay(0)" :class="{'item': true, 'select': selectIndex === 0}">
                <div class="title">自建活动</div>
                <div class="tips">通过资鲸平台进行活动报名和活动推广展示。</div>
                <img class="selectImg" v-show="selectIndex === 0" :src="require('@/common/images/activeOperate/select.png')" alt="">
            </div>
            <div @click="changeWay(1)" :class="{'item': true, 'select': selectIndex === 1}">
                <div class="title">第三方活动</div>
                <div class="tips">通过第三方平台进行活动报名，资鲸平台仅用于推广展示。</div>
                <img class="selectImg" v-show="selectIndex === 1" :src="require('@/common/images/activeOperate/select.png')" alt="">
            </div>
        </div>
        <div class="btnBox">
            <el-button class="cancel" @click="close">取 消</el-button>
            <el-button type="primary" @click="comfirm">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            centerDialogVisible: false,
            selectIndex: 0
        }
    },
    methods: {
        open() {
            this.centerDialogVisible = true
        },
        close() {
            this.centerDialogVisible = false
        },
        changeWay(index) {
            this.selectIndex = index
        },
        comfirm() {
            if (this.selectIndex === 0) {
                this.$router.push({name: 'CreateActive'})
            } else {
                this.$router.push({name: 'CreateOtherActive'})
            }
        }
    }
}
</script>
<style lang="scss">
    .selectWay {
        .wayBox {
            display: flex;
            align-items: center;
            justify-content: center;
            .item {
                width: 190px;
                height: 130px;
                border: 1px solid #E5E5E5;
                padding: 0 10px;
                box-sizing: border-box;
                position: relative;
                cursor: pointer;
                .title {
                    font-size: 14px;
                    padding: 20px 0 10px;
                    text-align: center;
                }
                .tips {
                    font-size: 14px;
                    color: #999999;
                    line-height: 20px;
                }
                .selectImg {
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 20px;
                    height: 20px;
                }
                &:not(:last-of-type) {
                    margin-right: 48px;
                }
                &.select {
                    border-color: #409EFF;
                    .title {
                        color: #409EFF;
                    }
                }
            }
        }
        .btnBox {
            margin-top: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            .el-button {
                margin: 0;
            }
            .cancel {
                margin-right: 20px;
            }
        }
    }
</style>